import { Repository } from "src/firebase/firestore/repository";
import { Topic } from "./entities/ai-topic.entity";

class AITopicRepository extends Repository<Topic> {
  constructor() {
    super("ai_topics");
  }

  async findById(id: string): Promise<Topic | null> {
    return await super.findById(id) as Topic | null;
  }

  async find(args: any): Promise<(Topic & { id: string })[]> {
    return await super.find(args) as (Topic & { id: string })[];
  }

  async count(where?: any): Promise<number> {
    return await super.count(where);
  }
}

export const aiTopicRepository = new AITopicRepository();
